module.exports = __webpack_public_path__ + "static/media/birds-noises.1c52a3ff.mp3";